/* @flow */

import classNames from 'classnames';
import { compose } from 'ramda';
import * as React from 'react';
import { createUseStyles } from 'react-jss';

import styles from './LengthCounter.style';

type Props = {
  count: number,
  maxLength: number,
};

const useStyles = createUseStyles(styles);

const LengthCounter = ({ count, maxLength }: Props): React.Node => {
  const classes: Object = useStyles();

  // Classes
  const rootClasses = classNames(classes.root, {
    [`${classes['root-error']}`]: count > Number(maxLength),
    [`${classes['root-maxValue']}`]: count === Number(maxLength),
  });

  return <span className={rootClasses}>{`${count}/${maxLength}`}</span>;
};

export default compose(React.memo)(LengthCounter);
